import transformColor from './transformColor'
import { Theme } from '@mui/material'

const statisticColors = (theme: Theme): string[] => {
  const countColors = 7
  const statisticColors:string[] = []

  const greyVariants = [
    transformColor('#323232', 20, false),
    transformColor('#323232', 50, false),
    '#323232',
    transformColor('#969696', 30, false),
    '#454545',
    '#969696',
    transformColor('#969696', 30, true),
  ]

  if (statisticColors.length < countColors) {
    if (statisticColors.length === 0) {
      const transformValues = [
        { percent: 0, darker: false },
        { percent: 20, darker: false },
        { percent: 40, darker: false },
        { percent: 60, darker: false },
        { percent: 20, darker: false },
        { percent: 40, darker: true },
        { percent: 60, darker: false },
      ]
      for (let i = 0; i <= countColors; i++) {
        if ((i % 2) === 0) {
          statisticColors.push(greyVariants[i])
        } else {
          statisticColors.push(transformColor(theme.palette.primary.main, transformValues[i]?.percent, transformValues[i]?.darker))
        }
      }
    }
    if (statisticColors.length < countColors) {
      const index = statisticColors.length
      for (let i = statisticColors.length; i < countColors; i++) {
        statisticColors.push(greyVariants[i - index])
      }
    }
  }

  return statisticColors
}

export default statisticColors
